module.exports = {"title":"INHERITED VOID 1ST EDITION","background":"/assets/simurgh.jpg","color":"#fff","type":"feed","stream_url":""}